import { setCookie } from "@trustpilot/businessapp-browserstorage";

import { localStorageKeys } from "../components/constants";

const determineCookieDomain = (url: Location): string => {
  // Return null for localhost so it can be omitted
  if (url.host.match(/localhost/)) {
    return null;
  }

  // For other domains, the domain must contain exactly two dots
  // Example: .trustpilot.com / .tp-local.com
  // This takes off any port, takes the last two parts of the host (split by dot)
  // and puts them together again
  const parts = url.host.replace(/:\d{4}/, "").split(".");
  return `.${parts.filter((a, i) => i >= parts.length - 2).join(".")}`;
};

const setBusinessUnitCookie = (businessUnitId: string, url: Location) => {
  const domain = determineCookieDomain(url);
  setCookie("tp-b2b-selected-business-unit-id", businessUnitId, {
    maxAge: 60 * 60 * 24 * 365,
    path: "/",
    // On localhost cookie domains must be omitted, not just set to null
    ...(domain ? { domain } : {}),
  });
};

export const setSessionStorage = () => {
  sessionStorage.setItem(
    `${localStorageKeys.accountselector.context}-${localStorageKeys.accountselector.names.hideSelectorModal}`,
    "true",
  );
};

const removeBusinessUnitIdSearchParam = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete("businessUnitId");
  return url;
};

export const changeBusinessUnit = (businessUnitId: string) => {
  setBusinessUnitCookie(businessUnitId, window.location);

  // when we switch b.unit, remove businessUnitId url param:
  const url = removeBusinessUnitIdSearchParam();

  window.location.href = url.href;
};
